import { render, staticRenderFns } from "./shipmentFlowView.vue?vue&type=template&id=ff4f44f2&scoped=true"
import script from "./shipmentFlowView.vue?vue&type=script&lang=js"
export * from "./shipmentFlowView.vue?vue&type=script&lang=js"
import style0 from "./shipmentFlowView.vue?vue&type=style&index=0&id=ff4f44f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4f44f2",
  null
  
)

export default component.exports